/** Minimal toast host + imperative helper (aria-live friendly). */

import { createContext, useContext, useState, type ReactNode } from 'react';

type Toast = { id: number; text: string };
let pushToast: ((t: string) => void) | null = null;

export const ToastContext = createContext<{ toast: (text: string) => void }>({
  toast: () => {},
});

export function useToast() {
  return useContext(ToastContext);
}

export function ToastHost({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Toast[]>([]);

  pushToast = (text: string) => {
    const id = Date.now() + Math.random();
    setItems((cur) => [...cur, { id, text }]);
    setTimeout(() => setItems((cur) => cur.filter((t) => t.id !== id)), 3500);
  };

  return (
    <ToastContext.Provider value={{ toast: (text) => pushToast?.(text) }}>
      {children}
      <div className="toast-host" role="status" aria-live="polite">
        {items.map((t) => (
          <div key={t.id} className="toast">
            {t.text}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
